import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Form, Input, Modal } from "antd";

import Swal from "sweetalert2";

const EditDefaultVideoComponent = ({ selectKey, linkList, setLinkList }) => {
	const isLoading = useSelector((state) => state.common.loading);
	const [linkCount, setLinkCount] = useState(0);

	const [exampleModal, setExampleModal] = useState(false);
	const [example, setExample] = useState("");

	useEffect(() => {
		if (selectKey?.associatedVideoList) {
			setLinkCount(selectKey?.associatedVideoList?.length);
			const list = selectKey?.associatedVideoList;
			setLinkList(list ? [...list] : []);
		} else {
			setLinkCount(0);
			setLinkList([]);
		}
	}, [selectKey]);

	/**
	 * 링크 개수 카운트로 처리하기
	 * @param type
	 * add, delete
	 */
	const handleLinkCount = (type, idx) => {
		let count = linkCount;
		if (type === "add") {
			count += 1;
			setLinkCount(count);
		} else {
			if (count >= 1) {
				Swal.fire({
					customClass: "alert-custom",
					text: `해당 링크를 삭제하시겠습니까?`,
					showCancelButton: true,
					confirmButtonText: "확인",
					cancelButtonText: "취소",
				}).then(async (result) => {
					if (result.isConfirmed) {
						linkList.splice(idx, 1);
						count -= 1;
						setLinkCount(count);
					}
				});
			}
		}
	};

	/**
	 * 링크 리스트 수정
	 * @param e
	 * title, url
	 * @param idx
	 */
	const handleLinkList = (e, idx) => {
		let list = [...linkList];
		let { name, value } = e.target;
		if (name === "url") {
			if (value.includes("https://")) {
				value = value.split("https://")[1];
			}
			const urlValue = "https://" + value;
			list[idx] = {
				...list[idx],
				[name]: urlValue,
			};
		} else {
			list[idx] = {
				...list[idx],
				[name]: value,
			};
		}
		setLinkList(list);
	};

	return (
		<div className={`body-default-each`}>
			<p className={`body-each-title`}>
				콘텐츠 링크
				<span
					className={`example`}
					onClick={() => {
						setExampleModal(true);
						setExample("contents");
					}}
				>
					예시
				</span>
				{/*<span className={`required`}/>*/}
			</p>
			{Array.from({ length: linkCount }).map((item, idx) => (
				<Form
					layout={"vertical"}
					className={`form-border`}
					key={`form-vertical-${idx}`}
				>
					<Form.Item
						label={
							<div className={`row-space-label`}>
								<p>{idx + 1 > 9 ? idx + 1 : "0" + (idx + 1)}</p>
								<Button
									size={`small`}
									onClick={() => handleLinkCount("delete", idx)}
								>
									삭제
								</Button>
							</div>
						}
						labelAlign="left"
						colon={false}
						className={`form-border-item item-vertical`}
					>
						<Form layout={"horizontal"}>
							<Form.Item
								label={"콘텐츠 제목"}
								labelAlign="left"
								colon={false}
								className={`category-link-form-item`}
								labelCol={{ span: 5 }}
							>
								<Input
									type={`text`}
									name={`title`}
									value={linkList[idx]?.title}
									onChange={(e) => handleLinkList(e, idx)}
								/>
							</Form.Item>
							<Form.Item
								label={"콘텐츠 링크"}
								labelAlign="left"
								colon={false}
								className={`category-link-form-item link-https`}
								labelCol={{ span: 5 }}
							>
								<Input
									type={`text`}
									name={`url`}
									addonBefore="https://"
									value={linkList[idx]?.url?.split("//")[1]}
									onChange={(e) => handleLinkList(e, idx)}
									className={`url-link`}
								/>
							</Form.Item>
							<Form.Item
								label={"검색 태그"}
								labelAlign="left"
								colon={false}
								className={`category-link-form-item`}
								labelCol={{ span: 5 }}
							>
								<Input
									type={`text`}
									name={`search_tag`}
									value={linkList[idx]?.search_tag}
									onChange={(e) => handleLinkList(e, idx)}
									placeholder={`"," 로 구분하여 입력해주세요. EX) 피로, 피로회복, 피로감, 피로할 때, 피로 영양제..`}
								/>
							</Form.Item>
						</Form>
					</Form.Item>
				</Form>
			))}

			<Button
				size={"small"}
				className={`edit-gray-btn`}
				style={{
					// borderRadius: "5px",
					// width: "50%",
					margin: "1em auto",
					padding: "0.3em 1.5em",
					height: "auto",
				}}
				loading={isLoading}
				onClick={() => handleLinkCount("add")}
				// disabled={!Object.keys(selectKey)?.length}
				disabled={
					!selectKey || (!!selectKey && !Object.keys(selectKey)?.length)
				}
			>
				<img
					src={`/assets/images/channel/plus-circle.png`}
					alt={`관련 성분 추가하기`}
					style={{
						width: "auto",
						height: "1em",
					}}
				/>
				콘텐츠 추가하기
			</Button>

			<Modal
				title="콘텐츠 예시"
				wrapClassName="sms-send-modal"
				open={exampleModal}
				centered={true}
				onCancel={() => {
					setExampleModal(!exampleModal);
				}}
				width="60%"
				footer={null}
				style={{
					maxWidth: 900,
				}}
			>
				<img
					src={`/assets/images/landing/${example}.jpg`}
					alt={`예시 모달`}
					style={{
						height: "auto",
						width: "100%",
					}}
				/>
			</Modal>
		</div>
	);
};
export default EditDefaultVideoComponent;
